export const getMaxDurationDaysForProductType = (productType: string): number => {
  if (productType === 'ldp') {
    return 180;
  }
  return 60;
};
